import { render, staticRenderFns } from "./PageTestingDailyGameLanding.vue?vue&type=template&id=2c1b6df8&scoped=true&"
import script from "./PageTestingDailyGameLanding.vue?vue&type=script&lang=js&"
export * from "./PageTestingDailyGameLanding.vue?vue&type=script&lang=js&"
import style0 from "./PageTestingDailyGameLanding.vue?vue&type=style&index=0&id=2c1b6df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1b6df8",
  null
  
)

export default component.exports